import { useGraphQLQuery } from '@betterment/js-runtime';

import { ActiveIraContributionsAndMatchGrantsByYearQueryResult } from './data';
import { ActiveIraContributionsAndMatchGrantsByYearDocument } from './graphql/query.ActiveIraContributionsAndMatchGrantsByYear.generated';

export const useActiveIraContributionsAndMatchGrantsByYearQuery =
  (): ActiveIraContributionsAndMatchGrantsByYearQueryResult => {
    const { data } = useGraphQLQuery(ActiveIraContributionsAndMatchGrantsByYearDocument, { throwOnError: true });

    const isLoading = !data;

    return {
      isLoading,
      iraContributions: data?.iraContributions?.byYear,
      iraContributionMatchGrants: data?.iraContributionMatchGrants,
      messages: data?.messages,
    };
  };
